<!--  -->
<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="divcss5">
            <el-row>
                <el-col :span="4"><div class="grid-content" /></el-col>
            </el-row>
            <el-row>
                <el-col :span="4"><div class="grid-content" /></el-col>
                <h1>{{ $t("offering.offeringReleaseOK") }}</h1>
            </el-row>
            <el-row>
                <el-col :span="4"><div class="grid-content" /></el-col>
            </el-row>
            <el-row>
                <el-col :span="4"><div class="grid-content" /></el-col>
                <el-link type="primary" :underline="false" @click="copyOffering">{{ $t("offering.offeringReleasecopy") }}</el-link>
            </el-row>
            <el-row>
                <el-col :span="4"><div class="grid-content" /></el-col>
                <el-link type="primary" :underline="false" @click="createOffering">{{ $t("offering.newOffering") }}</el-link>
            </el-row>
        </div>
    </el-card>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      dataForm: {
        offeringId: ''
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 创建新的排期
    createOffering () {
      this.tabRemove()
      this.$router.push({
        name: 'learning-offering-offeringEdit'
      })
      this.$eventHub.$emit('offbaseAdd', '')
    },
    // 复制排期
    copyOffering () {
      this.$request.put(`/learning/base/offeringinfo/copyOffering`,
        this.dataForm
      ).then((res, total, code, data) => {
        this.tabRemove()
        // 复制后跳转编辑页面
        this.$router.push({
          path: 'learning-offering-offeringEdit',
          query: { offeringId: data.data.offeringId }
        })
        this.$eventHub.$emit('offbaseShow', '')
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.dataForm.offeringId = this.$route.query.offeringId
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted')
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    console.log('activated')
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.divcss5 {
    margin:0 auto;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
.el-link, .el-transfer-panel__filter .el-icon-circle-close {
    cursor: pointer;
}
</style>
